/* Snorevia · JS de las secciones sv- (sin dependencias) */
(function () {
  'use strict';
  if (window.__svLoaded) return;
  window.__svLoaded = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = !!(window.Shopify && window.Shopify.designMode);
  var locale = document.documentElement.lang || 'es-ES';
  var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
  var nf = new Intl.NumberFormat(locale, { style: 'currency', currency: currency });
  function money(cents) { return nf.format(cents / 100); }
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }

  /* ---------- reveal ---------- */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { threshold: 0.15 }) : null;
  function reveal(scope) {
    scope.querySelectorAll('.sv-reveal,[data-sv-reveal]').forEach(function (el) {
      if (design || reduce || !io) el.classList.add('is-in'); else io.observe(el);
    });
  }

  /* ---------- business days ---------- */
  function addBiz(d, n) { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) n--; } return d; }
  function fmtShort(d) { return d.toLocaleDateString(locale, { day: 'numeric', month: 'short' }).replace('.', ''); }
  function fmtLong(d) { return d.toLocaleDateString(locale, { day: 'numeric', month: 'long' }); }
  function xmasCutoff(maxDays) {
    var now = new Date(), cut = new Date(now.getFullYear(), 11, 24), k = maxDays;
    while (k > 0) { cut.setDate(cut.getDate() - 1); if (cut.getDay() % 6) k--; }
    return now <= cut ? cut : null;
  }
  window.SnoreviaXmasCutoff = function (maxDays) { var c = xmasCutoff(maxDays); return c ? fmtLong(c) : null; };

  /* ---------- announcement ---------- */
  function initAnn(sec) {
    var items = [].slice.call(sec.querySelectorAll('[data-sv-ann-item]'));
    items.forEach(function (p) {
      var max = parseInt(p.getAttribute('data-xmas-days'), 10);
      if (max) { var c = xmasCutoff(max); if (c) p.textContent = p.getAttribute('data-xmas-text').replace('[fecha]', fmtLong(c)); else p.remove(); }
    });
    items = [].slice.call(sec.querySelectorAll('[data-sv-ann-item]'));
    if (!items.length) return;
    items.forEach(function (p, i) { p.classList.toggle('is-on', i === 0); });
    if (items.length < 2 || reduce) return;
    var i = 0, speed = (parseInt(sec.getAttribute('data-speed'), 10) || 4) * 1000;
    clearInterval(sec._svTimer);
    sec._svTimer = setInterval(function () {
      var cur = items[i]; cur.classList.remove('is-on'); cur.classList.add('is-out');
      i = (i + 1) % items.length; var nx = items[i]; nx.classList.remove('is-out'); nx.classList.add('is-on');
      setTimeout(function () { cur.classList.remove('is-out'); }, 500);
    }, speed);
  }

  /* ---------- buy box ---------- */
  function countTo(el, to) {
    if (!el) return;
    var from = parseFloat(el.getAttribute('data-v')); el.setAttribute('data-v', to);
    if (reduce || isNaN(from)) { el.textContent = money(to); return; }
    var t0 = performance.now(), d = 450;
    (function step(t) { var k = Math.min(1, (t - t0) / d), e = 1 - Math.pow(1 - k, 3); el.textContent = money(Math.round(from + (to - from) * e)); if (k < 1) requestAnimationFrame(step); })(t0);
  }

  function initBuy(sec) {
    var dataEl = sec.querySelector('[data-sv-product]');
    if (!dataEl) return;
    var product = JSON.parse(dataEl.textContent);
    var bumpEl = sec.querySelector('[data-sv-bump]');
    var bumpVariant = bumpEl ? JSON.parse(bumpEl.getAttribute('data-sv-bump')) : null;
    var bumpChk = bumpEl ? bumpEl.querySelector('input') : null;
    var groups = [].slice.call(sec.querySelectorAll('[data-sv-option]'));
    var idInput = sec.querySelector('input[name="id"]');
    var btn = sec.querySelector('[data-sv-add]');
    var btnLbl = btn ? btn.querySelector('.sv-btn__lbl') : null;
    var soldOut = btn ? btn.getAttribute('data-soldout') : 'Agotado';
    var addLbl = btn ? btn.getAttribute('data-label') : '';
    var after = sec.getAttribute('data-after') || 'cart';
    var current = null;

    function selected() { return groups.map(function (g) { var c = g.querySelector('[aria-checked="true"]'); return c ? c.getAttribute('data-value') : null; }); }
    function findVariant() {
      var sel = selected();
      return product.variants.find(function (v) { return v.options.every(function (o, i) { return sel[i] === null || o === sel[i]; }); }) || product.variants[0];
    }
    function total() { return current.price + (bumpChk && bumpChk.checked && bumpVariant ? bumpVariant.price : 0); }
    function render() {
      current = findVariant();
      if (idInput) idInput.value = current.id;
      countTo(sec.querySelector('[data-sv-price]'), current.price);
      var cmp = sec.querySelector('[data-sv-compare]'), save = sec.querySelector('[data-sv-save]');
      if (current.compare_at_price && current.compare_at_price > current.price) {
        cmp.hidden = false; save.hidden = false; cmp.textContent = money(current.compare_at_price);
        save.textContent = save.getAttribute('data-prefix') + ' ' + money(current.compare_at_price - current.price);
      } else { cmp.hidden = true; save.hidden = true; }
      if (btn) {
        btn.disabled = !current.available;
        if (btnLbl) btnLbl.innerHTML = current.available ? addLbl + ' · <span data-sv-btnprice></span>' : soldOut;
        var bp = btn.querySelector('[data-sv-btnprice]'); if (bp) bp.textContent = money(total());
      }
      var sp = sec.querySelector('[data-sv-sticky-price]'); if (sp) sp.textContent = money(total());
      var sn = sec.querySelector('[data-sv-sticky-name]'); if (sn) sn.textContent = current.title + (bumpChk && bumpChk.checked ? ' + ' + bumpEl.getAttribute('data-short') : '');
      if (bumpEl) bumpEl.classList.toggle('is-on', !!(bumpChk && bumpChk.checked));
      if (current.featured_media && current.featured_media.id) showMedia(String(current.featured_media.id));
    }
    function showMedia(mid) {
      var target = sec.querySelector('[data-sv-slide][data-sv-media="' + mid + '"]');
      if (!target) return;
      sec.querySelectorAll('[data-sv-slide]').forEach(function (s) { s.classList.toggle('is-on', s === target); });
      sec.querySelectorAll('[data-sv-thumb]').forEach(function (x) { x.setAttribute('aria-current', x.getAttribute('data-sv-media') === mid ? 'true' : 'false'); });
    }
    function choose(btnEl, focus) {
      var g = btnEl.closest('[data-sv-option]');
      g.querySelectorAll('[role="radio"]').forEach(function (b) { b.setAttribute('aria-checked', 'false'); b.tabIndex = -1; });
      btnEl.setAttribute('aria-checked', 'true'); btnEl.tabIndex = 0; if (focus) btnEl.focus();
      var lab = sec.querySelector('[data-sv-optlabel="' + g.getAttribute('data-sv-option') + '"]');
      if (lab) lab.textContent = btnEl.getAttribute('data-value');
      render();
    }
    groups.forEach(function (g) {
      var radios = [].slice.call(g.querySelectorAll('[role="radio"]'));
      radios.forEach(function (r, i) {
        r.addEventListener('click', function () { choose(r); });
        r.addEventListener('keydown', function (e) {
          var n = null;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') n = radios[(i + 1) % radios.length];
          if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') n = radios[(i - 1 + radios.length) % radios.length];
          if (n) { e.preventDefault(); choose(n, true); }
        });
      });
    });
    if (bumpChk) bumpChk.addEventListener('change', render);

    /* gallery */
    var slides = [].slice.call(sec.querySelectorAll('[data-sv-slide]'));
    sec.querySelectorAll('[data-sv-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        var idx = t.getAttribute('data-sv-thumb');
        slides.forEach(function (s) { s.classList.toggle('is-on', s.getAttribute('data-sv-slide') === idx); });
        sec.querySelectorAll('[data-sv-thumb]').forEach(function (x) { x.setAttribute('aria-current', x === t ? 'true' : 'false'); });
      });
    });

    /* add to cart */
    var form = sec.querySelector('form[data-sv-form]');
    if (form) form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      var items = [{ id: current.id, quantity: 1 }];
      if (bumpChk && bumpChk.checked && bumpVariant) items.push({ id: bumpVariant.id, quantity: 1 });
      btn.disabled = true;
      fetch(root() + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { if (!r.ok) throw r; return r.json(); })
        .then(function () {
          btn.classList.add('is-added');
          setTimeout(function () { window.location.href = after === 'checkout' ? root() + 'checkout' : root() + 'cart'; }, reduce ? 0 : 700);
        })
        .catch(function () { btn.disabled = false; form.submit(); });
    });

    /* delivery timeline */
    var tl = sec.querySelector('[data-sv-tl]');
    if (tl) {
      var now = new Date(), g = function (a) { return parseInt(tl.getAttribute(a), 10) || 0; };
      var s1 = addBiz(now, g('data-ship-min')), s2 = addBiz(now, g('data-ship-max')), d1 = addBiz(now, g('data-del-min')), d2 = addBiz(now, g('data-del-max'));
      var e1 = tl.querySelector('[data-sv-ship]'), e2 = tl.querySelector('[data-sv-del]');
      if (e1) e1.textContent = g('data-ship-max') ? fmtShort(s1) + ' – ' + fmtShort(s2) : fmtShort(now);
      if (e2) e2.textContent = fmtShort(d1) + ' – ' + fmtShort(d2);
      var xm = tl.querySelector('[data-sv-xmas]');
      if (xm) { var c = xmasCutoff(g('data-del-max')); if (c) xm.textContent = xm.getAttribute('data-text').replace('[fecha]', fmtLong(c)); else xm.remove(); }
    }

    /* sticky */
    var sticky = sec.querySelector('[data-sv-sticky]');
    if (sticky && btn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { var e = es[0]; sticky.classList.toggle('is-show', !e.isIntersecting && e.boundingClientRect.top < 0); }).observe(btn);
      var sb = sticky.querySelector('button');
      if (sb) sb.addEventListener('click', function () { btn.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); });
    }

    /* external selection (kits / CTA) */
    sec._svSelect = function (pos, withBump) {
      var g0 = sec.querySelector('[data-sv-pack]') || groups[0];
      if (g0 && pos) { var r = g0.querySelectorAll('[role="radio"]')[pos - 1]; if (r) choose(r); }
      if (bumpChk && typeof withBump === 'boolean') { bumpChk.checked = withBump; render(); }
      var target = g0 || btn; if (target) target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    };
    render();
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-sv-select]');
    if (!t) return;
    var buy = document.querySelector('[data-sv-buy]');
    if (!buy || !buy._svSelect) return;
    e.preventDefault();
    var b = t.getAttribute('data-sv-bump');
    buy._svSelect(parseInt(t.getAttribute('data-sv-select'), 10), b === null ? undefined : b === 'true');
  });

  /* ---------- before / after ---------- */
  function initBA(sec) {
    var night = sec.querySelector('.sv-night'); if (!night) return;
    var bb = sec.querySelector('[data-sv-before]'), ba = sec.querySelector('[data-sv-after]'), knob = sec.querySelector('.sv-toggle__knob');
    var label = night.querySelector('.sv-night__label'), cap = night.querySelector('.sv-night__cap');
    function setKnob(b) { if (knob && b) { knob.style.width = b.offsetWidth + 'px'; knob.style.transform = 'translateX(' + (b.offsetLeft - 4) + 'px)'; } }
    function mode(after) {
      night.classList.toggle('is-after', after); bb.setAttribute('aria-pressed', !after); ba.setAttribute('aria-pressed', after); setKnob(after ? ba : bb);
      label.textContent = night.getAttribute(after ? 'data-label-after' : 'data-label-before');
      cap.textContent = night.getAttribute(after ? 'data-cap-after' : 'data-cap-before');
    }
    bb.addEventListener('click', function () { mode(false); }); ba.addEventListener('click', function () { mode(true); });
    setTimeout(function () { setKnob(bb); }, 50);
    window.addEventListener('resize', function () { setKnob(night.classList.contains('is-after') ? ba : bb); });
    if (sec.getAttribute('data-auto') === 'true' && !reduce && !design && 'IntersectionObserver' in window) {
      var o = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { setTimeout(function () { mode(true); }, 900); o.disconnect(); } }, { threshold: 0.6 });
      o.observe(night);
    }
  }

  /* ---------- init ---------- */
  function init(scope) {
    scope = scope || document;
    reveal(scope);
    scope.querySelectorAll('[data-sv-ann]').forEach(initAnn);
    scope.querySelectorAll('[data-sv-buy]').forEach(initBuy);
    scope.querySelectorAll('[data-sv-ba]').forEach(initBA);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
